import SettlementPaymentsActionButtons from "./SettlementPaymentsActionButtons";
import SettlementPaymentsAmountFields from "./SettlementPaymentsAmountFields";
import SettlementPaymentsDateFields from "./SettlementPaymentsDateFields";
import SettlementPaymentsModalField from "./SettlementPaymentsModalField";
import SettlementPaymentsModalHeader from "./SettlementPaymentsModalHeader";
import SettlementPaymentsPartyFields from "./SettlementPaymentsPartyFields";
import SettlementPaymentsPrimaryFields from "./SettlementPaymentsPrimaryFields";
import SettlementPaymentsTextField from "./SettlementPaymentsTextField";

export default function SettlementPaymentsForm({
  title,
  caseDetail,
  casePk,
  values,
  paymentTypeOptions,
  loading,
  cancelDisabled = false,
  saveDisabled,
  onChange,
  onCancel,
  onSave,
}) {
  return (
    <div>
      <SettlementPaymentsModalHeader title={title} caseDetail={caseDetail} />

      <div className="flex flex-col gap-4 p-6">
        <SettlementPaymentsPrimaryFields
          values={values}
          paymentTypeOptions={paymentTypeOptions}
          onChange={onChange}
        />
        <SettlementPaymentsPartyFields casePk={casePk} values={values} onChange={onChange} />
        <SettlementPaymentsAmountFields values={values} onChange={onChange} />
        <SettlementPaymentsDateFields values={values} onChange={onChange} />

        <SettlementPaymentsModalField
          label="Notes"
          renderValue={
            <SettlementPaymentsTextField
              fieldName="notes"
              fieldValue={values.notes}
              onChange={onChange}
              multiline
            />
          }
        />
      </div>

      <SettlementPaymentsActionButtons
        disableCancel={loading || cancelDisabled}
        disableSave={loading || saveDisabled}
        handleOnClickCancelBtn={onCancel}
        handleOnClickSaveButton={onSave}
        saveLabel="Save"
      />
    </div>
  );
}
